module.exports = __webpack_public_path__ + "img/bg2.eaf45bf2.jpg";